var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartTypePieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 3.5,
    fill: "var(--report-widget-icon-fill)",
    stroke: "var(--report-widget-icon-fill)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7099 13.5801V22.29H28.4198C28.4198 27.1053 24.5252 30.9999 19.7099 30.9999C14.8946 30.9999 11 27.1053 11 22.29C11 17.4746 14.8946 13.5801 19.7099 13.5801Z",
    fill: "var(--report-widget-icon-stroke)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.29 19.7099V11C27.1054 11 30.9999 14.8946 30.9999 19.7099H22.29Z",
    fill: "#F37321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTypePieIcon);
export default __webpack_public_path__ + "static/media/chart-type-pie-icon.73ce97b693f9b513380c191fe1183dc4.svg";
export { ForwardRef as ReactComponent };